export default "__VITE_ASSET__228c0351__"